import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'gensan-ichiran',
    title: '放課後等デイサービス・児童発達支援の減算一覧と減算率',
    description:
        '放課後等デイサービスと児童発達支援で押さえるべき減算は8種類。支援プログラム未公表の15%減から児発管欠如の70/100まで、減算率・適用単位・起算する月・サービス別の対象可否を1枚の表にまとめました。複数の減算が重なったときの計算方法と、減算率を掛ける相手が加算前の基本報酬である点も条文つきで整理しています。',
    excerpt:
        '減算は8種類あります。減算率も、起算する月も、利用者全員か子どもごとかも違います。自分の事業所がどれに該当しうるかを、一覧表と自己点検リストで一度に確認してください。',
    category: '運営指導',
    keywords: [
        '放課後等デイサービス 減算',
        '児童発達支援 減算 一覧',
        '減算 率',
        '障害児通所支援 減算',
        '減算 起算'
    ],
    publishedAt: '2026-04-14',
    updatedAt: '2026-09-17',
};
